import { Avatar, Box, Typography } from "@mui/material";
import { FONT_PRIMARY, FONT_SECONDARY } from "@/theme/typography";

interface IProps {
  label: string;
  iconUrl: string;
}
const Label: React.FC<IProps> = ({ label, iconUrl }) => {
  return (
    <Box
      display="flex"
      gap={1}
      justifyContent="start"
      alignItems="center"
      mb={{ xs: 2, md: 5 }}
    >
      <Avatar
        src={iconUrl}
        sx={{ width: { xs: 16, md: 24 }, height: { xs: 16, md: 24 } }}
      />
      <Typography
        variant="subtitle2"
        fontWeight={600}
        fontFamily={{ xs: FONT_SECONDARY, md: FONT_PRIMARY }}
        color="text.accent"
      >
        {label}
      </Typography>
    </Box>
  );
};

export default Label;
